import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=494ff912&scoped=true&functional=true&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "494ff912",
  null
  
)

export default component.exports